import Basic from '@/components/page/Basic.js'
import { Penanggalan, AxiosWithJar, Config } from '@/utility.js'

export default{
	extends: Basic,
	props:[],
	data:()=>({
        clearing: {uncleared:[]},
        clearingedc: {uncleared:[]},
		loading: { table:true },
	}),
	methods:{

        //used
		async loadUncleared() {
			/*
			//By Salesarea
			let url = Config().apiURL + "/finance/dcreport?detail1=area&date-range-start=" + this.clearingStartDate + "&date-range-end=" + this.clearingEndDate + "&area=&status=UNCLEARED&type=SPBU"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.data.length) {
					this.clearing.uncleared = result.data.data;
				}
			})
			*/

			//By Region
			let url = Config().apiURL + "/finance/dcreport?detail1=region&date-range-start=" + this.clearingStartDate + "&date-range-end=" + this.clearingEndDate + "&area=&status=UNCLEARED&type=SPBU"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.data.length) {
					this.clearing.uncleared = result.data.data;
				}
			})
		},

		async loadEdcUncleared() {
			let url = Config().apiURL + "/finance/edc-overview?detail1=region&date-range-start=" + this.clearingStartDate + "&date-range-end=" + this.clearingEndDate + "&area=&status=UNCLEARED&type=SPBU"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.data.length) {
					this.clearingedc.uncleared = result.data.data;
				}
			})
		},

	},
    computed: {
		clearingStartDate() {
			return Penanggalan().tahunSekarang;
		},
		clearingEndDate() {
			var today = new Date();
			var dt = new Date(today.getTime() - ((1000*60*60*24) * (today.getDay() >= 4 ? 3 : (today.getDay() >= 1 ? 5 : 4))));
			return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
		}
    }
}
